import React from 'react';
import { BodyLarge, BodyRegular, BodySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import styled from "styled-components";
import { useSelector } from "react-redux";
import { selectConfig } from "@shared/store/config.duck";
import { UserInfo } from '@shared/models/user.models';
import { selectCurrentUser } from "@shared/store/auth.duck";
import { isCompanyAdminUser } from "@shared/utils/AccessControl";
import { useTranslation } from "react-i18next";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';

export function UserHolidayAllowanceSection(props: Props) {
  const config = useSelector(selectConfig);
  const currentUser = useSelector(selectCurrentUser);
  const {t} = useTranslation();
  const canEditHolidayAllowances = isCompanyAdminUser(currentUser);

  return (
    <Wrapper className="" data-test="location-section">
      <BodyLarge colour={Colours.blue} style={{marginBottom: 6}}>{t('settings-page.edit-user.holiday-allowance')}</BodyLarge>
      <BodyRegular style={{marginBottom: 6}}>{t('settings-page.edit-user.holiday-allowance-message')}</BodyRegular>

      {currentUser?.companyEntity.enableHolidayBooking && canEditHolidayAllowances && <OutlineButton link={`/manage/holidays/settings/allowance?userId=${props.user.userId}`}
                                                                                                     style={{'margin': '0 0 24px 0', width: '280px', maxWidth: '300px'}}
                                                                                                     text={'settings.holiday-allowance.edit-individual-allowances'} />}

      {props.user.holidayAllowance ?
        <BodySmall>{t('settings-page.edit-user.holiday-allowance-taken-from-users-setting')}</BodySmall> :
          <>{config.companyHolidayAllowance ? <BodySmall>{t('settings-page.edit-user.holiday-allowance-taken-from-company-setting')}</BodySmall> :
            <BodySmall>{t('settings-page.edit-user.holiday-allowance-not-yet-set')}</BodySmall>
          }</>
        }

    </Wrapper>
  )
}

interface Props {
  user: UserInfo;
}


const Wrapper = styled.div`
  border-bottom: 1px solid ${Colours.mildGrey};
  margin-bottom: 24px;
  padding-bottom: 24px;
  .textField__input {
    width: 80px;
  }
`
